import { SecondaryButton, useRegion } from '@monthio/react-components'
import { VoidFunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import { customBanks } from '../customBanks'
import { FlowPage } from '@monthio/design-system'
import { routeCodes } from '#modules/Bank/Bank.types'
import styled from "styled-components";

export const GridLayout = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 12px;
	column-gap: 12px;
	padding: 8px;
`

const ProfileWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
	height: 100%;
	padding-left: 5px;
	padding-bottom: 3px;
`
const Header = styled.span`
	font-weight: bold;
	font-size: 16px;
	margin-bottom: 3px;
	text-align: left;
	width: 100%;
`
const Highlight = styled.span`
	text-align: left;
	width: 100%;
`

export const PredefinedProfileSelector: VoidFunctionComponent<{
	monthioInternalBankId: number | null
}> = ({ monthioInternalBankId }) => {
	const history = useHistory()
	const { regionId } = useRegion()

	return (
		<FlowPage.Content>
			<GridLayout>
				{customBanks
					.filter((bank) => bank.regions.includes(regionId))
					.map((bankProfile) => {
						return (
							<SecondaryButton
								key={bankProfile.id + bankProfile.header}
								onClick={() => {
									history.replace({
										pathname: routeCodes.bankSessionOverviewPage,
										state: {
											consentCode: bankProfile.id,
											monthioInternalBankId,
											authUrl: 'customBank',
										},
									})
								}}
							>
								<ProfileWrapper>
									<Header>
									{bankProfile.header}
									</Header>
									{bankProfile.highlights.map((highlight) => (
										<Highlight
											key={highlight}
										>
										{'- '} {highlight}
									</Highlight>
									))}
								</ProfileWrapper>
							</SecondaryButton>
						)
					})}
			</GridLayout>
		</FlowPage.Content>
	)
}
